import * as React from 'react';
import { graphql } from 'gatsby';

import ProductPageLayout from '../components/productPage';
import HeadMetadata from '../components/head';
import Layout from '../components/layout';
import Footer from '../components/footer';
import { getCurrentNodeByLocale } from '../utils';
import { HOST_NAME } from '../constants';

const PageHeader = () => (
  <div className="cmp-experiencefragment">
    <div className="cmp-container">
      <div className="container responsivegrid header-containers--main">
        <div id="headerExperienceMainContainer" className="cmp-container"></div>
      </div>
    </div>
  </div>
);

const ProductPage = (props) => {
  const currentLocaleCode = props.pageContext?.locale;
  const siteSettings = getCurrentNodeByLocale(
    props.data.allContentstackSiteSettings.nodes,
    currentLocaleCode
  );

  return (
    <Layout
      header={PageHeader()}
      siblingsPages={props.pageContext?.siblingsPages}
      currentLocaleCode={currentLocaleCode}
    >
      <ProductPageLayout
        product={props.data.contentstackProductSetPage}
        siteSettings={siteSettings}
        currentLocaleCode={currentLocaleCode}
      />

      <Footer isProductSetPage={true} currentLocaleCode={currentLocaleCode} />
    </Layout>
  );
};

export default ProductPage;

export const Head = (props) => {
  const currentLocaleCode = props.pageContext?.locale;
  const siteSettings = getCurrentNodeByLocale(
    props.data.allContentstackSiteSettings.nodes,
    currentLocaleCode
  );

  return (
    <>
      <HeadMetadata
        title={props.data.contentstackProductSetPage.seo.title}
        description={props.data.contentstackProductSetPage.seo.description}
        keywords={props.data.contentstackProductSetPage.seo.keywords}
        canonical={`${HOST_NAME}${props.pageContext.pagePath}`}
        seo={siteSettings?.seo}
        externalHreflangs={props.data.contentstackProductSetPage.seo?.external_hreflangs}
      />
      <body className="page basicpage" />
    </>
  );
};

export const pageQuery = graphql`
  query ($id: String) {
    contentstackProductSetPage(id: { eq: $id }) {
      title
      url
      content
      images {
        url
        title
        description
      }
      price_spider_id
      bazaar_voice_id
      related_products {
        title
        url
        seo {
          title
        }
        images {
          url
          title
        }
      }
      page_list {
        url
        date_text: custom_publish_date(formatString: "MMMM YYYY")
        date_number: custom_publish_date(formatString: "YYYY-MM-DD")
        publish_details {
          date_text: time(formatString: "MMMM YYYY")
          date_number: time(formatString: "YYYY-MM-DD")
        }
        cta {
          title
          description
          urltext
          images {
            href
          }
        }
      }
      seo {
        title
        description
        external_hreflangs {
          hreflang
          url
        }
        keywords
      }
      variants {
        image {
          url
          title
        }
        title
        sku
      }
      instructions {
        row {
          image {
            url
            title
          }
          content_left
          content_right
        }
      }
      safety_informations_and_ingredients {
        tab {
          title
          content
        }
      }
      url_more
      urltext_more
    }

    allContentstackSiteSettings(
      filter: { domain_name: { eq: "airwick.us" }, locale: { in: ["en-us", "en-es"] } }
    ) {
      nodes {
        locale
        ...FragmentContentstackSiteSettingsSeo
        ...FragmentContentstackSiteSettingsProductSetPage
        bazaarvoice_url
      }
    }
  }
`;
